<template>
  <div class="overall-bg header-top p-0">
    <ApprovalConfirmation v-if="
      ApprovalListchange.length != 0 &&
      ApprovalListchange.some((item) => item['IsApproved'] == 0) &&
      Number(QueryStringValue?.IsApproval) !== 1
    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
      @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" :RejectBtnHide="true" />
    <ApprovalStatus v-if="
      ApprovalList.length != 0 && Number(QueryStringValue?.IsApproval) !== 1
    " :ApprovalgetList="ApprovalList" :approvaldetails="approvaldetails" />
    <b-container fluid class="ps-0">
      <b-row>
        <b-col lg="3" xl="3" xxl="3" md="3" sm="2" class="staticleftsidebar"
          v-if="windowWidth > 545 && Number(QueryStringValue?.IsApproval) !== 1">
          <LeftBar pagename="IssueReturnDetails" masterheading="Returns" v-model="Id" :storestatus="true"
            :listed="sidebardata" :paramValues="ParamValues" :loading="loading" x>
          </LeftBar>
          <a class="back-btn" @click="goToFirstPage">
            <img alt="Vue logo" class="back" src="../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="9" xl="9" xxl="9" md="9" sm="10">
          <b-container>
            <b-row>
              <SidebarList v-if="loading && Number(QueryStringValue?.IsApproval) !== 1" class="mt-3" />
              <b-col class="mt-4" v-else>
                <BacktoPage :goback="$router.back" class="my-5" v-if="windowWidth <= 545"></BacktoPage>
                <div class="d-flex align-items-center justify-content-between">
                  <Headerlayout :headertext="FromStoreName"></Headerlayout>
                  <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
                </div>
              </b-col>
            </b-row>
            <div v-if="windowWidth > 545">
              <div v-if="items.length !== 0" class="">
                <section v-if="items.length !== 0" class="details_collapse">
                  <DetailsBanner :details="data" :loading="loading" class="mb-2" />
                </section>
              </div>
              <SkeletonTableLoader :columns="headers" :loading="loading" />
              <div v-if="!loading">
                <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Return"
                  econtent="Return" eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                  :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading"
                  responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                  :filters="filters">
                  <template v-slot:Add> </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <EditIcon />
                      <DeleteIcon />
                    </span>
                  </template>
                </Tableview>
              </div>
            </div>
            <div v-if="windowWidth <= 545">
              <MobileLoader v-if="loading" v-for="item in 5" />
              <div v-if="!loading">
                <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Return"
                  econtent="Return" eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                <MobileViewCardHeader>
                  <template v-slot:mobilecard>
                    <div class="mobile-card" v-for="item in items">
                      <div class="d-flex align-items-center gap-1">
                        <p class="light-name">{{ item["RefNo"] }} /</p>
                        <p class="light-name">{{ item["ItemCode"] }} /</p>
                        <p class="light-name1">{{ item["HSNCode"] }}</p>
                      </div>
                      <p class="name">{{ item["Itemname1"] }}</p>
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Requested Quantity :</p>
                        <p class="small-name">
                          {{
                            item["RequestedQty"] ? item["RequestedQty"] : "0"
                          }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Received Quantity :</p>
                        <p class="small-name">
                          {{ item["IssuedQty"] ? item["IssuedQty"] : "0" }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Returns :</p>
                        <p class="small-name">
                          {{
                            item["ItemQuantity"] ? item["ItemQuantity"] : "0"
                          }}
                        </p>
                      </div>
                    </div>
                  </template>
                </MobileViewCardHeader>
              </div>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  onUnmounted,
} from "vue";
import LeftBar from "../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import POTableview from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../../../modules/Inventory/pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../../modules/Inventory/Service/ManufacturerService";
import commonService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import WithoutStockService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import ManufacturerMasterTableview from "../../../../../modules/Inventory/pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ManufacturerItemMappingTable from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import Service from "../../../../../modules/Inventory/Service/StockOutService";
import stockinservice from "../../../../../modules/Inventory/Service/StockInService";
import SidebarList from "../../../../../components/SkeletonLoaderComponents/SidebarList.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import DetailsBanner from "../../../../../modules/Inventory/components/Transaction/detailsbanner.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import ServiceIn from "../../../../../modules/Inventory/Service/StockInService";
import moment from "moment";
import ApprovalConfirmation from "../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../components/FormComponents/ApprovalStatus.vue";
import ApprovalService from "../../../../../modules/Inventory/Service/PoApprovalService";
import StockInService from "../../../../../modules/Inventory/Service/StockInService";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ManufacturerItemMappingTable,
    Tableview,
    Loader,
    SidebarList,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    BacktoPage,
    DetailsBanner,
    ApprovalConfirmation,
    ApprovalStatus,
    CrystalReportPrintPopUp
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    propsParams: {
      type: Object,
    },
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let rolesData;
    let SessionRolesData = localStorage.getItem("RolesData");
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const { t } = useI18n();
    let loading = ref(false);

    let items = ref([]);
    let loading1 = ref(false);

    let sidebardata = ref([]);
    let Id = ref([]);
    const route = useRoute();
    let FromStoreName = ref("");
    let ToStoreName = ref("");

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    let QueryStringValue = ref(route.query);

    watch(
      () => [props.Operations, props.ApprovalObj],
      async ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.id) {
          const response = await StockInService.GetByStockInId(
            newOperations.id
          );
          newOperations.refid = response["result"].RefId;
          QueryStringValue.value = newOperations;
        }
        if (newApprovalObj.Status) {
          isForm.value.IsApproved = newApprovalObj.Status;
          UpdateApprovalStatus();
        }
      },
      { immediate: true, deep: true }
    );

    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      tostoreid: "",
      RequesterName: "",
      id: ref(),
      date: ref(),
    });
    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);
    let approvaldetails: any = ref({
      HeaderName: "InBound Issue",
      ContentName: "InBound Issue",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });
    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0,
    });
    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });
    async function getApprovaldata() {
      debugger;
      let EntityId = 3030;
      try {
        let response = await ApprovalService.GetPOApprovalList(
          QueryStringValue.value.id,
          usersData.OrganizationId,
          QueryStringValue.value.BranchId,
          EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"];
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }
    async function Approve(Values) {
      debugger;
      try {
        let rowToAssign = null;
        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }
        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = 3030;
        }
        let response;
        if (isForm.value.IsApproved == 1) {
          response = await ApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await ApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
        await IsShowByStockOutId();
      } catch (error) {
        console.log(error);
      }
    }
    async function UpdateApprovalStatus() {
      debugger;
      try {
        const response = await StockInService.UpdateApprovalStatus(
          QueryStringValue.value.id,
          isForm.value.IsApproved
        );
        const response1 =
          await StockInService.UpdateStockInDetailApprovalStatus(
            QueryStringValue.value.id,
            isForm.value.IsApproved
          );
        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
        }
      } catch (error) {
        console.log(error);
      }
    }
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (QueryStringValue.value.type == "Outbound") {
        IsShowStockin();
      } else {
        IsShow();
        getApprovaldata();
      }
      IsShowByStockOutId();
    });

    const router = useRouter();
    const routerChangeCount = ref(0);

    onBeforeRouteUpdate(() => {
      routerChangeCount.value++;
    });
    const goToFirstPage = () => {
      setupHistoryManagement(router, 5);
    };

    const headers = [
      {
        header: t("storetabdetails.issuereturndetails.Id"),
        field: "RefNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuereturndetails.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t("storetabdetails.issuereturndetails.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.issuereturndetails.Batch"),
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuereturndetails.UOM"),
        field: "UOMName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuereturndetails.ReqQty"),
        field: "RequestedQty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.issuereturndetails.IssueQty"),
        field: "IssuedQty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.issuereturndetails.ReturnedQty"),
        field: "ItemQuantity",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.issuereturndetails.Reason"),
        field: "ReasonName",
        class: "smallwidth",
        bodyclass: "right_td",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    async function IsShow() {
      debugger;

      try {
        loading.value = true;
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await ServiceIn.List(
          "",
          "",
          "13",
          "",
          "",
          "StoreId",
          ParamValues.value.StoreId,
          "",
          "",
          "",
          "",
          1,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          Condition
        );
        console.log(response["result"]);
        sidebardata.value = response["result"];
        const oldKey1 = "ToStoreName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";
        const oldKey3 = "StockOutTransId";
        const newKey3 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
            [newKey3]: item[oldKey3],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          delete newItem[oldKey3];
          return newItem;
        });
        console.log(sidebardata.value);
        FromStoreName.value = response["result"][0].FromStoreName;
        console.log(FromStoreName.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    async function IsShowStockin() {
      debugger;
      try {
        loading.value = true;
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await Service.listStockOutMasterTM(
          "",
          "",
          "",
          "",
          "13",
          "StoreId",
          ParamValues.value.StoreId,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          1,
          "",
          Condition
        );

        console.log(response["result"]);
        sidebardata.value = response["result"];
        const oldKey1 = "ToStoreName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";
        const oldKey3 = "StockOutTransId";
        const newKey3 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
            [newKey3]: item[oldKey3],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          delete newItem[oldKey3];
          return newItem;
        });
        console.log(sidebardata.value);
        FromStoreName.value = response["result"][0].FromStoreName;
        console.log(FromStoreName.value);

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    debugger;
    const ParamValues = ref({
      Id: 0,
      StoreId: 0,
      refid: 0,
    });
    ParamValues.value.Id = Number(QueryStringValue.value.id);
    ParamValues.value.refid = Number(QueryStringValue.value.refid);
    ParamValues.value.StoreId = Number(QueryStringValue.value.storeid);
    console.log(ParamValues.value.Id);

    watch(
      () => QueryStringValue.value.id,
      (newVal: any) => {
        debugger;
        ParamValues.value.Id = Number(newVal);
        ParamValues.value.StoreId = Number(QueryStringValue.value.storeid);
        ParamValues.value.refid = Number(QueryStringValue.value.refid);
        IsShowByStockOutId();
        getApprovaldata();
      }
    );
    let IssueId = ref("");
    async function IsShowByStockOutId() {
      loading.value = true;
      try {
        const result = await Service.GetById(
          QueryStringValue.value.type == "Outbound"
            ? ParamValues.value.Id
            : ParamValues.value.refid
        );
        console.log(result["result"]);
        let message = result["ErrorInfo"].ErrorCode;
        if (message == null) {
          console.log(result["result"]);
          if (result["result"].length != 0) {
            IssueId.value = result["result"][0].DocNo;
            items.value = result["result"];
            console.log(items.value);
            ToStoreName.value = result["result"][0].ToStoreName;
            const totalIssueQty = computed(() => {
              return items.value.reduce(
                (sum, item: any) => sum + item.IssuedQty,
                0
              );
            });

            const totalItemQty = computed(() => {
              return items.value.reduce(
                (sum, item: any) => sum + item.RequestedQty,
                0
              );
            });
            data.value.fromstr = result["result"][0].FromStoreName;
            data.value.tostr = result["result"][0].ToStoreName;
            data.value.fromstoreid = result["result"][0].FromStoreCode;
            data.value.tostoreid = result["result"][0].ToStoreCode;
            data.value.fromstatus = result["result"][0].FromStoreType;
            data.value.tostatus = result["result"][0].ToStoreType;
            data.value.fromcount = totalItemQty;
            data.value.tocount = totalIssueQty;
            data.value.id = result["result"][0].DocNo;
            data.value.RequesterName = result["result"][0].CreatedByName;
            data.value.date = moment(result["result"][0].DocDateHR).format(
              "DD-MM-YYYY"
            );
            approvaldetails.value.ApprovalCode = result["result"][0]?.DocNo;
            approvaldetails.value.ApprovalDate = result["result"][0].DocDateHR;
            approvaldetails.value.CreatedAt = result["result"][0].CreatedAt;
          }
        }
        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    const CrystalReportPopup = ref(false);
    const ParameterValues = ref({
      Id: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: QueryStringValue.value.type == "Inbound" ? 81 : 66,
      HeaderTitle: "Issue Return",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = QueryStringValue.value.id;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };



    return {
      data,
      sidebardata,
      IsShow,
      Id,
      loading1,
      headers,
      globalFilterFields,
      filters,
      items,
      ParamValues,
      IssueId,
      loading,
      FromStoreName,
      ToStoreName,
      routerChangeCount,
      goToFirstPage,
      windowWidth,
      ApprovalList,
      ApprovalListchange,
      approvaldetails,
      getApprovaldata,
      Approve,
      SuccessfullPopUp,
      QueryStringValue,
      Print,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      hidepopup,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
